import type { ReactNode } from 'react'
import styles from './StatusLine.module.css'

interface StatusLineProps {
    label: string
    children: ReactNode
    /** Renders the value in the muted colour, for absent or placeholder data. */
    muted?: boolean
    /** Machine output -- addresses, AS numbers -- gets the monospace face. */
    mono?: boolean
}

/** A `label` / `value` reading row, ruled off from the one above it. */
export default function StatusLine({ label, children, muted, mono }: StatusLineProps) {
    const value = [muted ? styles.valueMuted : styles.value, mono ? styles.mono : '']
        .filter(Boolean).join(' ')

    return (
        <div className={styles.row}>
            <span className={styles.label}>{label}</span>
            <span className={value}>{children}</span>
        </div>
    )
}
